import App from "../../app";
import { FilterValue } from "../../lib/filter";
import { ListFrontend } from "../frontend";
import {
	AttemptId,
	ProductId,
	ItemId,
	QuizId
} from "../../model/datasource";
import { AnswerType } from "../../lib/userdata";

export abstract class ListView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: ListFrontend<I>;

	protected constructor(frontend?: ListFrontend<I>) {
		this.frontend = frontend;
	}

	abstract init(app: App<P, A, Z, I>): void

	abstract displaySelectedAnswer(item: I, answer: AnswerType | null, status?: "loading" | "error" | undefined): void
	abstract displayCurrent(index: number): void
	abstract displayFilters(filters: FilterValue[], bindTarget: EventTarget): void
	abstract displayFiltered(filtered: number[]): void
	abstract displayFlagged(item: I, flagged: boolean, status?: undefined | "loading" | "error"): void
	abstract displaySorted(order: number[]): void
}

export class NullListView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> implements ListView<P, A, Z, I> {
	frontend: ListFrontend<I>;

	init(app: App<P, A, Z, I>): void { }

	displaySelectedAnswer(item: I, answer: AnswerType | null, status?: "loading" | "error" | undefined): void {
		throw new Error("Method not implemented.");
	}

	displayCurrent(index: number): void {
		throw new Error("Method not implemented.");
	}

	displayFilters(filters: FilterValue[], bindTarget: EventTarget): void {
		throw new Error("Method not implemented.");
	}

	displayFiltered(filtered: number[]): void {
		throw new Error("Method not implemented.");
	}

	displayFlagged(item: I, flagged: boolean, status?: undefined | "loading" | "error"): void {
		throw new Error("Method not implemented.");
	}

	displaySorted(order: number[]): void {
		throw new Error("Method not implemented.");
	}
}

